<template>
  <v-card>
    <v-toolbar
      dark
      color="primary"
    >
      <v-btn
        icon
        dark
        @click="$emit('dialog-close')"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>Buy It Now</v-toolbar-title>
    </v-toolbar>

    <v-card-title>{{ flipAsset.title }}<br>{{ flipAsset.buyItNowPrice | numberToMoney }}</v-card-title>

    <v-card-subtitle class="mt-1 mb-8 pb-0">A <strong>$2000 down payment</strong> is required to purchase this asset.</v-card-subtitle>

    <v-card-text>
      <IntegrationSelect
          v-model="integrationId"
          ></IntegrationSelect>
    </v-card-text>
    <v-card-actions>
      <v-card-subtitle>
        You are placing a down payment for an order to buy <strong>{{ flipAsset.title }}</strong> for <strong>{{ flipAsset.buyItNowPrice | numberToMoney }}</strong>. The selected payment method will be charged <strong>$2000</strong>.
      </v-card-subtitle>
      <v-btn
        color="primary"
        :loading="loading"
        :disabled="!integrationId"
        @click="buyIt"
        class="mr-3"
      >
        Purchase
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import IntegrationSelect from './IntegrationSelect.vue'

  export default {
    name: 'BuyItNowForm',

    components: {
      IntegrationSelect
    },

    computed: {
      ...mapGetters([
        'flipAsset',
        'user'
      ])
    },

    data: () => ({
      loading: false,
      integrationId: ''
    }),

    methods: {
      ...mapActions([
        'buyItNow'
      ]),

      buyIt: function () {
        this.loading = true
        console.log(`integration id: ${this.integrationId}`)

        this.buyItNow({
          assetId: this.flipAsset.id,
          payload: { userIntegrationId: this.integrationId }
        }).then(() => {
          console.log(`You bought the car! id: ${this.flipAsset.id}`)
          this.loading = false
          this.$emit('dialog-close')
        })
      }
    },

    mounted() {
    }
  }
</script>
